import React, { useState, useEffect, Fragment } from 'react';

import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';

export default function NonWorkforceCostsSection(props) {
    const [displayDepartments, setDisplayDepartments] = useState({});
    const [displayCostcenters, setDisplayCostcenters] = useState({});

    useEffect(() => {
        const data = props.data.os_expenditure.non_workforce_costs;
        const departmentsIds = {};
        const costcentersIds = {};

        Object.keys(data.departments).forEach((depId) => {
            const departmentData = data.departments[depId];
            departmentsIds[depId] = false;
            const cc = _.isArray(departmentData.costcenters) || !departmentData.costcenters ? {} : departmentData.costcenters;
            Object.keys(cc).forEach((ccId) => {
                costcentersIds[ccId] = false;
            });
        });

        setDisplayDepartments(departmentsIds);
        setDisplayCostcenters(costcentersIds);
    }, []);

    const changeInput = (e, departmentId, key, ccId = null, expenseId = null) => {
        props.changeInput(e, departmentId, key, ccId, expenseId);
    };

    const toggleDepartmentDataVisibility = (depId) => {
        const departments = { ...displayDepartments };
        departments[depId] = !departments[depId];
        setDisplayDepartments(departments);
    };

    const toggleCCDataVisibility = (ccId) => {
        const cc = { ...displayCostcenters };
        cc[ccId] = !cc[ccId];
        setDisplayCostcenters(cc);
    };

    return (
        <Fragment>
            <tr className="!tw-bg-white">
                <td className="tw-font-semibold" colSpan={100}>
                    {$t(_.startCase(props.subGroup.replace('_', ' ')))}
                </td>
            </tr>
            {Object.keys(props.data[props.groupKey][props.subGroup].departments).map((depId) => {
                const departmentData = props.data[props.groupKey][props.subGroup].departments[depId];

                const costcenters = _.isArray(departmentData.costcenters) ? {} : departmentData.costcenters;
                const rowKey = depId;
                const rowTitle = departmentData.name;
                const value = departmentData.value;

                const localPercent = departmentData.data?.local_percent ?? 0;
                const indirectPercent = departmentData.data?.indirect_percent ?? 0;
                const inducedPercent = departmentData.data?.induced_percent ?? 0;
                const totalDirect = (value * localPercent) / 100 ?? 0;
                const totalIndirect = (totalDirect * indirectPercent) / 100 ?? 0;
                const totalInduced = (totalDirect * inducedPercent) / 100 ?? 0;

                const depExpenses = _.isArray(departmentData.expenses) ? {} : departmentData.expenses;

                return (
                    <Fragment key={props.groupKey + '_' + props.subGroup + '_' + rowKey}>
                        <tr className="tw-bg-blue-25">
                            <td
                                className="tw-cursor-pointer"
                                onClick={() => {
                                    toggleDepartmentDataVisibility(depId);
                                }}
                            >
                                {!displayDepartments[depId] ? (
                                    <PlusIcon className="tw-w-3.5 tw-h-3.5" aria-hidden="true" />
                                ) : (
                                    <MinusIcon className="tw-w-3.5 tw-h-3.5" aria-hidden="true" />
                                )}
                                <span className={'pl-2'}>{rowTitle}</span>
                            </td>
                            <td>{props.format(value)}</td>

                            {props.cellKeys.map((cellKey) => {
                                return (
                                    <td key={props.groupKey + '_' + props.subGroup + '_' + rowKey + '_' + cellKey}>
                                        <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                            <input
                                                className="text-input"
                                                type={'number'}
                                                value={departmentData.data ? departmentData.data[cellKey] : 0}
                                                min="0"
                                                max="100"
                                                onChange={(e) => {
                                                    changeInput(e, depId, cellKey);
                                                }}
                                            />
                                        </div>
                                    </td>
                                );
                            })}
                            <td>{props.format(totalDirect)}</td>
                            <td>{props.format(totalIndirect)}</td>
                            <td>{props.format(totalInduced)}</td>
                        </tr>

                        <NonWorkforceExpenses
                            expenses={depExpenses}
                            marginLeft={'15px'}
                            marginLeft2={'25px'}
                            groupKey={props.groupKey}
                            subGroup={props.subGroup}
                            cellKeys={props.cellKeys}
                            changeInput={changeInput}
                            depId={depId}
                            ccId={null}
                            visible={displayDepartments[depId]}
                            format={props.format}
                        />

                        {/*Costcenters*/}
                        {!!costcenters && Object.keys(costcenters).length > 0 && (
                            <Fragment>
                                {displayDepartments[depId] && (
                                    <tr>
                                        <td colSpan={100}>
                                            <span style={{ marginLeft: '15px' }}>Costcenters</span>
                                        </td>
                                    </tr>
                                )}
                                {Object.keys(costcenters).map((ccId) => {
                                    const ccData = costcenters[ccId];
                                    const ccTitle = ccData.name;
                                    const ccValue = ccData.value;
                                    const localPercent = ccData.data.local_percent;
                                    const indirectPercent = ccData.data.indirect_percent;
                                    const inducedPercent = ccData.data.induced_percent;
                                    const totalDirect = (ccValue * localPercent) / 100;
                                    const totalIndirect = (totalDirect * indirectPercent) / 100;
                                    const totalInduced = (totalDirect * inducedPercent) / 100;

                                    const ccExpenses = _.isArray(ccData.expenses) ? {} : ccData.expenses;

                                    return (
                                        <Fragment key={props.groupKey + '_' + props.subGroup + '_costcenter_' + ccId}>
                                            {displayDepartments[depId] && (
                                                <tr>
                                                    <td
                                                        className="tw-cursor-pointer"
                                                        onClick={() => {
                                                            toggleCCDataVisibility(ccId);
                                                        }}
                                                    >
                                                        <span style={{ marginLeft: '25px' }}>
                                                            {!displayCostcenters[ccId] ? (
                                                                <PlusIcon className="tw-w-3.5 tw-h-3.5" aria-hidden="true" />
                                                            ) : (
                                                                <MinusIcon className="tw-w-3.5 tw-h-3.5" />
                                                            )}
                                                            <span className={'pl-2'}>{ccTitle}</span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div>{props.format(ccValue)}</div>
                                                    </td>

                                                    {props.cellKeys.map((cellKey) => {
                                                        return (
                                                            <td key={props.groupKey + '_' + props.subGroup + '_' + rowKey + '_' + ccId + '_' + cellKey}>
                                                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                                    <input
                                                                        className="text-input"
                                                                        type={'number'}
                                                                        value={ccData.data[cellKey]}
                                                                        min="0"
                                                                        max="100"
                                                                        onChange={(e) => {
                                                                            changeInput(e, depId, cellKey, ccId);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        );
                                                    })}
                                                    <td>{props.format(totalDirect)}</td>
                                                    <td>{props.format(totalIndirect)}</td>
                                                    <td>{props.format(totalInduced)}</td>
                                                </tr>
                                            )}
                                            <NonWorkforceExpenses
                                                expenses={ccExpenses}
                                                marginLeft={'30px'}
                                                marginLeft2={'35px'}
                                                groupKey={props.groupKey}
                                                subGroup={props.subGroup}
                                                cellKeys={props.cellKeys}
                                                changeInput={changeInput}
                                                depId={depId}
                                                ccId={ccId}
                                                visible={displayDepartments[depId] && displayCostcenters[ccId]}
                                                format={props.format}
                                            />
                                        </Fragment>
                                    );
                                })}
                            </Fragment>
                        )}
                    </Fragment>
                );
            })}
        </Fragment>
    );
}

const NonWorkforceExpenses = (props) => {
    return (
        <Fragment>
            {props.visible && (
                <tr>
                    <td colSpan={100}>
                        <span style={{ marginLeft: props.marginLeft }}>Expenses</span>
                    </td>
                </tr>
            )}

            {!!props.expenses &&
                Object.keys(props.expenses).map((id) => {
                    const expenseData = props.expenses[id];
                    const title = expenseData.name;
                    const value = expenseData.value;
                    const localPercent = expenseData.data ? expenseData.data.local_percent : 0;
                    const indirectPercent = expenseData.data ? expenseData.data.indirect_percent : 0;
                    const inducedPercent = expenseData.data ? expenseData.data.induced_percent : 0;
                    const totalDirect = (value * localPercent) / 100;
                    const totalIndirect = (totalDirect * indirectPercent) / 100;
                    const totalInduced = (totalDirect * inducedPercent) / 100;

                    return (
                        <Fragment key={props.groupKey + '_' + props.subGroup + '_expense_' + id}>
                            {props.visible && (
                                <tr>
                                    <td>
                                        <span style={{ marginLeft: props.marginLeft2 }}>{title}</span>
                                    </td>
                                    <td>{props.format(value)}</td>

                                    {props.cellKeys.map((cellKey) => {
                                        return (
                                            <td key={props.groupKey + '_' + props.subGroup + '_expense_' + id + '_' + cellKey}>
                                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                    <input
                                                        className="text-input"
                                                        type={'number'}
                                                        value={expenseData.data ? expenseData.data[cellKey] : 0}
                                                        min="0"
                                                        max="100"
                                                        onChange={(e) => {
                                                            props.changeInput(e, props.depId, cellKey, props.ccId, id);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        );
                                    })}
                                    <td>{props.format(totalDirect)}</td>
                                    <td>{props.format(totalIndirect)}</td>
                                    <td>{props.format(totalInduced)}</td>
                                </tr>
                            )}
                        </Fragment>
                    );
                })}
        </Fragment>
    );
};
